<template>
  <div class="main">
    <FormWrapper :action="formAction" :method="formMethod">
      <div class="title-bar">
        <h1 class="mb-0">{{ theme.id ? "Edit" : "Add New" }} Theme</h1>
        <a class="btn-back" :href="route('admin.themes.index')">
          <span class="icon icon-arrow-left"></span>
          <span class="text">Back to List</span>
        </a>
      </div>
      <div class="row no-gutters py-4">
        <div class="col-12 col-lg-8 col-xl-9">
          <div class="row no-gutters pl-4">
            <div class="col-12">
              <transition name="fade">
                <Alert v-if="hasAlert" :alert="alert" class="text-center" />
              </transition>
            </div>

            <div class="col-12 pb-4">
              <Field type="text" name="name" label="Name" validate="required" :value="theme.name" />
            </div>

            <div class="col-12">
              <hr />
              <h5 class="text-uppercase">Color Palette</h5>
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-md-3 mb-3">
              <ColorPicker
                label="Primary Color"
                name="colors[primary]"
                :value="theme.colors.primary"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-lg-3 mb-3">
              <ColorPicker
                label="Secondary Color"
                name="colors[secondary]"
                :value="theme.colors.secondary"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-md-3 mb-3">
              <ColorPicker
                label="Success Color"
                name="colors[success]"
                :value="theme.colors.success"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 mb-3">
              <ColorPicker label="Danger Color" name="colors[danger]" :value="theme.colors.danger" />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-md-3 mb-3">
              <ColorPicker
                label="Warning Color"
                name="colors[warning]"
                :value="theme.colors.warning"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-lg-3 mb-3">
              <ColorPicker
                label="Informational Color"
                name="colors[info]"
                :value="theme.colors.info"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-md-3 mb-3">
              <ColorPicker
                label="Light Grayscale Color"
                name="colors[light]"
                :value="theme.colors.light"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 mb-3">
              <ColorPicker
                label="Dark Grayscale Color"
                name="colors[dark]"
                :value="theme.colors.dark"
              />
            </div>

            <div class="col-12">
              <hr />
              <h5 class="text-uppercase">Primary Button Style</h5>
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-md-3 mb-3">
              <ColorPicker
                label="Background Color"
                name="colors[btn-primary]"
                :value="theme.colors['btn-primary']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-lg-3 mb-3">
              <ColorPicker
                label="Hover Color"
                name="colors[btn-primary-hover]"
                :value="theme.colors['btn-primary-hover']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-md-3 mb-3">
              <ColorPicker
                label="Text Color"
                name="colors[btn-primary-text]"
                :value="theme.colors['btn-primary-text']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 mb-3"></div>

            <div class="col-12">
              <hr />
              <h5 class="text-uppercase">Secondary Button Style</h5>
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-md-3 mb-3">
              <ColorPicker
                label="Background Color"
                name="colors[btn-secondary]"
                :value="theme.colors['btn-secondary']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-lg-3 mb-3">
              <ColorPicker
                label="Hover Color"
                name="colors[btn-secondary-hover]"
                :value="theme.colors['btn-secondary-hover']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-md-3 mb-3">
              <ColorPicker
                label="Text Color"
                name="colors[btn-secondary-text]"
                :value="theme.colors['btn-secondary-text']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 mb-3"></div>

            <div class="col-12">
              <hr />
              <h5 class="text-uppercase">Success Button Style</h5>
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-md-3 mb-3">
              <ColorPicker
                label="Background Color"
                name="colors[btn-success]"
                :value="theme.colors['btn-success']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-lg-3 mb-3">
              <ColorPicker
                label="Hover Color"
                name="colors[btn-success-hover]"
                :value="theme.colors['btn-success-hover']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-md-3 mb-3">
              <ColorPicker
                label="Text Color"
                name="colors[btn-success-text]"
                :value="theme.colors['btn-success-text']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 mb-3"></div>

            <div class="col-12">
              <hr />
              <h5 class="text-uppercase">Danger Button Style</h5>
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-md-3 mb-3">
              <ColorPicker
                label="Background Color"
                name="colors[btn-danger]"
                :value="theme.colors['btn-danger']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-lg-3 mb-3">
              <ColorPicker
                label="Hover Color"
                name="colors[btn-danger-hover]"
                :value="theme.colors['btn-danger-hover']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-md-3 mb-3">
              <ColorPicker
                label="Text Color"
                name="colors[btn-danger-text]"
                :value="theme.colors['btn-danger-text']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 mb-3"></div>

            <div class="col-12">
              <hr />
              <h5 class="text-uppercase">Warning Button Style</h5>
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-md-3 mb-3">
              <ColorPicker
                label="Background Color"
                name="colors[btn-warning]"
                :value="theme.colors['btn-warning']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-lg-3 mb-3">
              <ColorPicker
                label="Hover Color"
                name="colors[btn-warning-hover]"
                :value="theme.colors['btn-warning-hover']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-md-3 mb-3">
              <ColorPicker
                label="Text Color"
                name="colors[btn-warning-text]"
                :value="theme.colors['btn-warning-text']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 mb-3"></div>

            <div class="col-12">
              <hr />
              <h5 class="text-uppercase">Informational Button Style</h5>
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-md-3 mb-3">
              <ColorPicker
                label="Background Color"
                name="colors[btn-info]"
                :value="theme.colors['btn-info']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-lg-3 mb-3">
              <ColorPicker
                label="Hover Color"
                name="colors[btn-info-hover]"
                :value="theme.colors['btn-info-hover']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-md-3 mb-3">
              <ColorPicker
                label="Text Color"
                name="colors[btn-info-text]"
                :value="theme.colors['btn-info-text']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 mb-3"></div>

            <div class="col-12">
              <hr />
              <h5 class="text-uppercase">Light Grayscale Button Style</h5>
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-md-3 mb-3">
              <ColorPicker
                label="Background Color"
                name="colors[btn-light]"
                :value="theme.colors['btn-light']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-lg-3 mb-3">
              <ColorPicker
                label="Hover Color"
                name="colors[btn-light-hover]"
                :value="theme.colors['btn-light-hover']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-md-3 mb-3">
              <ColorPicker
                label="Text Color"
                name="colors[btn-light-text]"
                :value="theme.colors['btn-light-text']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 mb-3"></div>

            <div class="col-12">
              <hr />
              <h5 class="text-uppercase">Dark Grayscale Button Style</h5>
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-md-3 mb-3">
              <ColorPicker
                label="Background Color"
                name="colors[btn-dark]"
                :value="theme.colors['btn-dark']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-lg-3 mb-3">
              <ColorPicker
                label="Hover Color"
                name="colors[btn-dark-hover]"
                :value="theme.colors['btn-dark-hover']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-md-3 mb-3">
              <ColorPicker
                label="Text Color"
                name="colors[btn-dark-text]"
                :value="theme.colors['btn-dark-text']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 mb-3"></div>

            <div class="col-12">
              <hr />
              <h5 class="text-uppercase">Context Menus</h5>
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-md-3 mb-3">
              <ColorPicker
                label="Background Color"
                name="colors[menu-bg]"
                :value="theme.colors['menu-bg']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-lg-3 mb-3">
              <ColorPicker
                label="Text Color"
                name="colors[menu-text]"
                :value="theme.colors['menu-text']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-md-3 mb-3">
              <ColorPicker
                label="Arrow Icon Color"
                name="colors[menu-icon]"
                :value="theme.colors['menu-icon']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 mb-3"></div>

            <div class="col-12">
              <hr />
              <h5 class="text-uppercase">Sidebars</h5>
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-md-3 mb-3">
              <ColorPicker
                label="Background Color"
                name="colors[sidebar-bg]"
                :value="theme.colors['sidebar-bg']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-lg-3 mb-3">
              <ColorPicker
                label="Search Background Color"
                name="colors[sidebar-search-bg]"
                :value="theme.colors['sidebar-search-bg']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-md-3 mb-3">
              <ColorPicker
                label="Checkboxes and Radio Buttons"
                name="colors[sidebar-checkbox-bg]"
                :value="theme.colors['sidebar-checkbox-bg']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 mb-3"></div>
            <div class="col-12 col-md-6 col-lg-3 pr-md-3 mb-3">
              <ColorPicker
                label="Filter Menu Background"
                name="colors[sidebar-menu-bg]"
                :value="theme.colors['sidebar-menu-bg']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-lg-3 mb-3">
              <ColorPicker
                label="Active Filter Background"
                name="colors[sidebar-filter-bg]"
                :value="theme.colors['sidebar-filter-bg']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-md-3 mb-3">
              <ColorPicker
                label="Active Filter Text"
                name="colors[sidebar-filter-text]"
                :value="theme.colors['sidebar-filter-text']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 mb-3"></div>

            <div class="col-12">
              <hr />
              <h5 class="text-uppercase">Course Type Tabs</h5>
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-md-3 mb-3">
              <ColorPicker
                label="Default Background Color"
                name="colors[course-type-tab-bg]"
                :value="theme.colors['course-type-tab-bg']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-lg-3 mb-3">
              <ColorPicker
                label="Default Border Color"
                name="colors[course-type-tab-border]"
                :value="theme.colors['course-type-tab-border']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-md-3 mb-3">
              <ColorPicker
                label="Default Text Color"
                name="colors[course-type-tab-text]"
                :value="theme.colors['course-type-tab-text']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 mb-3"></div>
            <div class="col-12 col-md-6 col-lg-3 pr-md-3 mb-3">
              <ColorPicker
                label="Active Background Color"
                name="colors[course-type-tab-active-bg]"
                :value="theme.colors['course-type-tab-active-bg']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-lg-3 mb-3">
              <ColorPicker
                label="Active Border Color"
                name="colors[course-type-tab-active-border]"
                :value="theme.colors['course-type-tab-active-border']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 pr-md-3 mb-3">
              <ColorPicker
                label="Active Text Color"
                name="colors[course-type-tab-active-text]"
                :value="theme.colors['course-type-tab-active-text']"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-3 mb-3"></div>
          </div>
        </div>
        <div class="col-12 col-lg-4 col-xl-3 form-button-wrapper">
          <div class="sticky-top">
            <div class="text-center">
              <button type="submit" class="btn btn-success mr-2">Save Changes</button>
              <a class="btn btn-secondary" :href="route('admin.themes.index')">Cancel & Exit</a>
            </div>
            <div v-if="theme.id" class="font-size-sm text-center pt-4">
              <span>Last updated on {{ theme.updated_at | moment("MM/DD/YYYY") }}</span>
              <span>at {{ theme.updated_at | moment("h:mma") }}</span>
            </div>
          </div>
        </div>
      </div>
    </FormWrapper>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
export default {
  mixins: [DisplaysAlerts],
  props: {
    theme: { type: Object, required: true },
  },
  computed: {
    formAction() {
      return !this.theme.id
        ? this.route("admin.themes.store")
        : this.route("admin.themes.update", {
            theme: this.theme.id,
          });
    },
    formMethod() {
      return !this.theme.id ? "POST" : "PUT";
    },
  },
};
</script>